import React from 'react';
import { translations } from '../../utils/translations';
import { useApp } from '../../context/AppContext';

const ReceiptModal = ({ receipt, onClose }) => {
  const { language } = useApp();
  const t = translations[language];

  if (!receipt) return null;

  // 安全的数字格式化函数
  const formatMoney = (value) => {
    return parseFloat(value || 0).toFixed(2);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-gray-800 mb-2">{t.thankYou}</h3>
          <p className="text-gray-600">{receipt.orderNo}</p>
          <p className="text-sm text-gray-500">{receipt.date}</p>
        </div>
        
        <div className="border-t border-b py-4 mb-4">
          {receipt.items && receipt.items.map((item, idx) => (
            <div key={idx} className="flex justify-between mb-2">
              <span className="text-gray-700">{item.name} × {item.quantity || 0}</span>
              <span className="font-medium">
                {t.yuan}{formatMoney((item.price || 0) * (item.quantity || 0))}
              </span>
            </div>
          ))}
        </div>
        
        <div className="flex justify-between text-xl font-bold mb-6">
          <span>{t.total}:</span>
          <span className="text-blue-600">{t.yuan}{formatMoney(receipt.total)}</span>
        </div>
        
        <button
          onClick={onClose}
          className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
        >
          {t.confirm}
        </button>
      </div>
    </div>
  );
};

export default ReceiptModal;